// import React from "react";
// import { Link } from 'react-router-dom';
// import shape2 from '../../images/shapes/shape_section_divider_1.svg';
// import Bg from '../../images/about/whitepaper_image_bg.webp';
// import wImg from '../../images/about/pandapaper.png';
// // import wImg from '../../images/about/pandawhitepaper.png';
// // import wImg from '../../images/about/ico_whitepager_image.webp';
// import plogo1 from '../../images/partners/partner_logo_1.svg';
// import plogo2 from '../../images/partners/partner_logo_2.svg';
// import check from '../../icons/icon_check.svg';

// const WhitepaperSection = () => {

//   const ClickHandler = () => {
//     window.scrollTo(10, 0);
//   }

//   return (
//     <section
//       id="id_ico_whitepaper_section"
//       className="ico_whitepaper_section section_space pb-0 section_decoration section_shadow_top"
//     >
//       <div className="decoration_item shape_divider_1">
//         <img
//           src={shape2}
//           alt="Shape Divider"
//         />
//       </div>
//       <div className="container">
//         <div
//           className="ico_heading_block text-center mt-lg-4"
//           data-aos="fade-up"
//           data-aos-duration="800"
//         >
//           <h2 className="heading_text mb-0">Whitepaper</h2>
//         </div>

//         <div
//           className="whitepaper_content"
//           data-aos="fade-up"
//           data-aos-duration="800"
//           data-aos-delay="100"
//         >
//           <div className="row m-0 align-items-center">
//             <div className="col-lg-6 p-0">
//               <div
//                 className="whitepaper_image_wrap"
//                 style={{
//                   backgroundImage: {Bg},
//                 }}
//               >
//                 <div className="image_block">
//                   <img
//                     src={wImg}
//                     alt="ICO White Paper"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-6 p-0">
//               <div className="whitepaper_info_wrap">
//                 <div className="info_wrap_1">
//                   <h3 className="heading_text">Audit Results</h3>
//                   <p>
//                     Panda Sovereign has been successfully audited by the trusted
//                     organizations BitTorrent and Stacks. Passing these audits
//                     underscores our dedication to building a safe and robust
//                     solution for all users.
//                   </p>
//                   <ul className="partners_group unordered_list">
//                     <li>
//                       <div className="ico_partner_logo">
//                         <a className="logo_wrap" href="#!">
//                           <img
//                             src={plogo1}
//                             alt="Partner Logo"
//                           />
//                           <span className="dot_1"></span>
//                           <span className="dot_2"></span>
//                           <span className="dot_3"></span>
//                           <span className="dot_4"></span>
//                         </a>
//                       </div>
//                     </li>
//                     <li>
//                       <div className="ico_partner_logo">
//                         <a className="logo_wrap" href="#!">
//                           <img
//                             src={plogo2}
//                             alt="Partner Logo"
//                           />
//                           <span className="dot_1"></span>
//                           <span className="dot_2"></span>
//                           <span className="dot_3"></span>
//                           <span className="dot_4"></span>
//                         </a>
//                       </div>
//                     </li>
//                   </ul>
//                 </div>
//                 <div className="info_wrap_2">
//                   <h3 className="heading_text">Explore Whitepaper</h3>
//                   <p>
//                     Here is our full documents that help you to understand
//                     deeply about us and our operation.
//                   </p>
//                   <div className="row">
//                     <div className="col-md-6">
//                       <ul className="iconlist_block unordered_list_block">
//                         <li>
//                           <span className="iconlist_icon">
//                             <img
//                               src={check}
//                               alt="Icon Check"
//                             />
//                           </span>
//                           <span className="iconlist_label">White Paper.</span>
//                         </li>
//                         <li>
//                           <span className="iconlist_icon">
//                             <img
//                               src={check}
//                               alt="Icon Check"
//                             />
//                           </span>
//                           <span className="iconlist_label">Privacy & Policy.</span>
//                         </li>
//                       </ul>
//                     </div>
//                     <div className="col-md-6">
//                       <ul className="iconlist_block unordered_list_block">
//                         <li>
//                           <span className="iconlist_icon">
//                             <img
//                               src={check}
//                               alt="Icon Check"
//                             />
//                           </span>
//                           <span className="iconlist_label">Terms Of Coin Sale.</span>
//                         </li>
//                         <li>
//                           <span className="iconlist_icon">
//                             <img
//                               src={check}
//                               alt="Icon Check"
//                             />
//                           </span>
//                           <span className="iconlist_label">One Pager.</span>
//                         </li>
//                       </ul>
//                     </div>
//                   </div>
//                   <Link className="ico_creative_btn" to="#" onClick={ClickHandler}>
//                     <span className="btn_wrapper">
//                       <span className="btn_icon_left">
//                         <small className="dot_top"></small>
//                         <small className="dot_bottom"></small>
//                         <svg
//                           className="icon_arrow_left"
//                           viewBox="0 0 28 23"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path d="M13.4106 20.8083L5.36673 12.6878C5.26033 12.5804 5.11542 12.52 4.96423 12.52H1.84503C1.34158 12.52 1.08822 13.1276 1.44252 13.4852L9.48642 21.6057C9.59281 21.7131 9.73773 21.7736 9.88892 21.7736H13.0081C13.5116 21.7736 13.7649 21.166 13.4106 20.8083Z" />
//                           <path d="M12.6803 9.57324H24.71C25.7116 9.57324 26.5234 10.3851 26.5234 11.3866C26.5234 12.3882 25.7116 13.2 24.71 13.2H12.6803C11.6788 13.2 10.8669 12.3882 10.8669 11.3866C10.8669 10.3851 11.6788 9.57324 12.6803 9.57324Z" />
//                           <path d="M1.44252 9.28834L9.48641 1.16784C9.59281 1.06043 9.73772 1 9.88891 1H13.0081C13.5116 1 13.7649 1.60758 13.4106 1.96525L5.36672 10.0858C5.26033 10.1932 5.11541 10.2536 4.96422 10.2536H1.84502C1.34158 10.2536 1.08822 9.64601 1.44252 9.28834Z" />
//                         </svg>
//                       </span>
//                       <span className="btn_label">Download White Papper</span>
//                       <span className="btn_icon_right">
//                         <small className="dot_top"></small>
//                         <small className="dot_bottom"></small>
//                         <svg
//                           className="icon_arrow_right"
//                           viewBox="0 0 27 23"
//                           xmlns="http://www.w3.org/2000/svg"
//                         >
//                           <path d="M13.6558 2.19168L21.6997 10.3122C21.8061 10.4196 21.951 10.48 22.1022 10.48H25.2214C25.7248 10.48 25.9782 9.87238 25.6239 9.51478L17.58 1.39428C17.4736 1.28688 17.3287 1.22638 17.1775 1.22638H14.0583C13.5548 1.22638 13.3015 1.83398 13.6558 2.19168Z" />
//                           <path d="M14.3861 13.4268H2.35637C1.35486 13.4268 0.542969 12.6149 0.542969 11.6134C0.542969 10.6118 1.35486 9.79996 2.35637 9.79996H14.3861C15.3876 9.79996 16.1995 10.6118 16.1995 11.6134C16.1995 12.6149 15.3876 13.4268 14.3861 13.4268Z" />
//                           <path d="M25.6239 13.7117L17.58 21.8322C17.4736 21.9396 17.3287 22 17.1775 22H14.0583C13.5548 22 13.3015 21.3924 13.6558 21.0347L21.6997 12.9142C21.8061 12.8068 21.951 12.7464 22.1022 12.7464H25.2214C25.7248 12.7464 25.9782 13.354 25.6239 13.7117Z" />
//                         </svg>
//                       </span>
//                     </span>
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhitepaperSection;




"use client"

import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { useApi } from "../../hooks/useApi"
import shape2 from "../../images/shapes/shape_section_divider_1.svg"
import Bg from "../../images/about/whitepaper_image_bg.webp"
import wImg from "../../images/about/pandapaper.png"
import plogo1 from "../../images/partners/partner_logo_1.svg"
import plogo2 from "../../images/partners/partner_logo_2.svg"
import check from "../../icons/icon_check.svg"

const WhitepaperSection = () => {
  // const [whitepaperData, setWhitepaperData] = useState(null)
  // const [loading, setLoading] = useState(true)
  // const [error, setError] = useState(null)
  // const { get } = useApi()

  const { data: whitePaperData, loading, error } = useApi("/whitepaper")

  // useEffect(() => {
  //   const fetchWhitepaperData = async () => {
  //     try {
  //       setLoading(true)
  //       const response = await get("/whitepaper")
  //       if (response.success) {
  //         setWhitepaperData(response.data)
  //       } else {
  //         setError("Failed to load whitepaper data")
  //       }
  //     } catch (err) {
  //       setError("Error loading whitepaper data: " + err.message)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }

  //   fetchWhitepaperData()
  // }, [get])

  const ClickHandler = () => {
    window.scrollTo(10, 0)
  }

  // Default fallback data
  const defaultData = {
    heading: "Whitepaper",
    auditResults: {
      title: "Audit Results",
      description:
        "Panda Sovereign has been successfully audited by the trusted organizations BitTorrent and Stacks. Passing these audits underscores our dedication to building a safe and robust solution for all users.",
      partners: [
        { name: "Partner 1", logo: plogo1 },
        { name: "Partner 2", logo: plogo2 },
      ],
    },
    exploreWhitepaper: {
      title: "Explore Whitepaper",
      description: "Here is our full documents that help you to understand deeply about us and our operation.",
      documents: [
        { name: "White Paper.", link: "#" },
        { name: "Privacy & Policy.", link: "#" },
        { name: "Terms Of Coin Sale.", link: "#" },
        { name: "One Pager.", link: "#" },
      ],
    },
    whitepaperImage: wImg,
    backgroundImage: Bg,
  }

  // const data = whitepaperData || defaultData

  if (loading) {
    return (
      <section
        id="id_ico_whitepaper_section"
        className="ico_whitepaper_section section_space pb-0 section_decoration section_shadow_top"
      >
        <div className="decoration_item shape_divider_1">
          <img src={shape2 || "/placeholder.svg"} alt="Shape Divider" />
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }

  if (error) {
    console.warn("Whitepaper API Error:", error, "- Using default data")
  }

  return (
    <section
      id="id_ico_whitepaper_section"
      className="ico_whitepaper_section section_space pb-0 section_decoration section_shadow_top"
    >
      <div className="decoration_item shape_divider_1">
        <img src={shape2 || "/placeholder.svg"} alt="Shape Divider" />
      </div>
      <div className="container">
        <div className="ico_heading_block text-center mt-lg-4" data-aos="fade-up" data-aos-duration="800">
          <h2 className="heading_text mb-0">{whitePaperData.heading}</h2>
        </div>
        <div className="whitepaper_content" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
          <div className="row m-0 align-items-center">
            <div className="col-lg-6 p-0">
              <div
                className="whitepaper_image_wrap"
                style={{
                  backgroundImage: `url(${whitePaperData.backgroundImage || Bg})`,
                }}
              >
                <div className="image_block">
                  <img src={whitePaperData.whitepaperImage || wImg} alt="ICO White Paper" />
                </div>
              </div>
            </div>
            <div className="col-lg-6 p-0">
              <div className="whitepaper_info_wrap">
                <div className="info_wrap_1">
                  <h3 className="heading_text">{whitePaperData.auditResults.title}</h3>
                  <p>{whitePaperData.auditResults.description}</p>
                  <ul className="partners_group unordered_list">
                    {whitePaperData.auditResults.partners.map((partner, index) => (
                      <li key={index}>
                        <div className="ico_partner_logo">
                          <a className="logo_wrap" href="#!">
                            <img src={partner.logo || "/placeholder.svg"} alt={partner.name} />
                            <span className="dot_1"></span>
                            <span className="dot_2"></span>
                            <span className="dot_3"></span>
                            <span className="dot_4"></span>
                          </a>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="info_wrap_2">
                  <h3 className="heading_text">{whitePaperData.exploreWhitepaper.title}</h3>
                  <p>{whitePaperData.exploreWhitepaper.description}</p>
                  <div className="row">
                    <div className="col-md-6">
                      <ul className="iconlist_block unordered_list_block">
                        {whitePaperData.exploreWhitepaper.documents.slice(0, 2).map((doc, index) => (
                          <li key={index}>
                            <span className="iconlist_icon">
                              <img src={check || "/placeholder.svg"} alt="Icon Check" />
                            </span>
                            {/* <span className="iconlist_label">{doc.name}</span> */}
                            <a 
                              href={doc.link} 
                              target="_blank" 
                              className="iconlist_label"
                            >
                              {doc.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <ul className="iconlist_block unordered_list_block">
                        {whitePaperData.exploreWhitepaper.documents.slice(2, 4).map((doc, index) => (
                          <li key={index + 2}>
                            <span className="iconlist_icon">
                              <img src={check || "/placeholder.svg"} alt="Icon Check" />
                            </span>
                            {/* <span className="iconlist_label">{doc.name}</span> */}
                            <a 
                              href={doc.link} 
                              target="_blank" 
                              className="iconlist_label"
                            >
                              {doc.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  {/* <Link className="ico_creative_btn" to="#" onClick={ClickHandler}>
                    <span className="btn_wrapper">
                      <span className="btn_icon_left">
                        <small className="dot_top"></small>
                        <small className="dot_bottom"></small>
                        <svg className="icon_arrow_left" viewBox="0 0 28 23" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.4106 20.8083L5.36673 12.6878C5.26033 12.5804 5.11542 12.52 4.96423 12.52H1.84503C1.34158 12.52 1.08822 13.1276 1.44252 13.4852L9.48642 21.6057C9.59281 21.7131 9.73773 21.7736 9.88892 21.7736H13.0081C13.5116 21.7736 13.7649 21.166 13.4106 20.8083Z" />
                          <path d="M12.6803 9.57324H24.71C25.7116 9.57324 26.5234 10.3851 26.5234 11.3866C26.5234 12.3882 25.7116 13.2 24.71 13.2H12.6803C11.6788 13.2 10.8669 12.3882 10.8669 11.3866C10.8669 10.3851 11.6788 9.57324 12.6803 9.57324Z" />
                          <path d="M1.44252 9.28834L9.48641 1.16784C9.59281 1.06043 9.73772 1 9.88891 1H13.0081C13.5116 1 13.7649 1.60758 13.4106 1.96525L5.36672 10.0858C5.26033 10.1932 5.11541 10.2536 4.96422 10.2536H1.84502C1.34158 10.2536 1.08822 9.64601 1.44252 9.28834Z" />
                        </svg>
                      </span>
                      <span className="btn_label">Download White Papper</span>
                      <span className="btn_icon_right">
                        <small className="dot_top"></small>
                        <small className="dot_bottom"></small>
                        <svg className="icon_arrow_right" viewBox="0 0 27 23" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.6558 2.19168L21.6997 10.3122C21.8061 10.4196 21.951 10.48 22.1022 10.48H25.2214C25.7248 10.48 25.9782 9.87238 25.6239 9.51478L17.58 1.39428C17.4736 1.28688 17.3287 1.22638 17.1775 1.22638H14.0583C13.5548 1.22638 13.3015 1.83398 13.6558 2.19168Z" />
                          <path d="M14.3861 13.4268H2.35637C1.35486 13.4268 0.542969 12.6149 0.542969 11.6134C0.542969 10.6118 1.35486 9.79996 2.35637 9.79996H14.3861C15.3876 9.79996 16.1995 10.6118 16.1995 11.6134C16.1995 12.6149 15.3876 13.4268 14.3861 13.4268Z" />
                          <path d="M25.6239 13.7117L17.58 21.8322C17.4736 21.9396 17.3287 22 17.1775 22H14.0583C13.5548 22 13.3015 21.3924 13.6558 21.0347L21.6997 12.9142C21.8061 12.8068 21.951 12.7464 22.1022 12.7464H25.2214C25.7248 12.7464 25.9782 13.354 25.6239 13.7117Z" />
                        </svg>
                      </span>
                    </span>
                  </Link> */}
                  <Link
                    className="ico_creative_btn"
                    to={whitePaperData?.exploreWhitepaper?.downloadButton?.link || "#"}
                    target="_blank"
                    onClick={ClickHandler}
                  >
                    <span className="btn_wrapper">
                      <span className="btn_icon_left">
                        <small className="dot_top"></small>
                        <small className="dot_bottom"></small>
                        <svg className="icon_arrow_left" viewBox="0 0 28 23" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.4106 20.8083L5.36673 12.6878C5.26033 12.5804 5.11542 12.52 4.96423 12.52H1.84503C1.34158 12.52 1.08822 13.1276 1.44252 13.4852L9.48642 21.6057C9.59281 21.7131 9.73773 21.7736 9.88892 21.7736H13.0081C13.5116 21.7736 13.7649 21.166 13.4106 20.8083Z" />
                          <path d="M12.6803 9.57324H24.71C25.7116 9.57324 26.5234 10.3851 26.5234 11.3866C26.5234 12.3882 25.7116 13.2 24.71 13.2H12.6803C11.6788 13.2 10.8669 12.3882 10.8669 11.3866C10.8669 10.3851 11.6788 9.57324 12.6803 9.57324Z" />
                          <path d="M1.44252 9.28834L9.48641 1.16784C9.59281 1.06043 9.73772 1 9.88891 1H13.0081C13.5116 1 13.7649 1.60758 13.4106 1.96525L5.36672 10.0858C5.26033 10.1932 5.11541 10.2536 4.96422 10.2536H1.84502C1.34158 10.2536 1.08822 9.64601 1.44252 9.28834Z" />
                        </svg>
                      </span>

                      <span className="btn_label">
                        {whitePaperData?.exploreWhitepaper?.downloadButton?.label || "Download White Paper"}
                      </span>

                      <span className="btn_icon_right">
                        <small className="dot_top"></small>
                        <small className="dot_bottom"></small>
                        <svg className="icon_arrow_right" viewBox="0 0 27 23" xmlns="http://www.w3.org/2000/svg">
                          <path d="M13.6558 2.19168L21.6997 10.3122C21.8061 10.4196 21.951 10.48 22.1022 10.48H25.2214C25.7248 10.48 25.9782 9.87238 25.6239 9.51478L17.58 1.39428C17.4736 1.28688 17.3287 1.22638 17.1775 1.22638H14.0583C13.5548 1.22638 13.3015 1.83398 13.6558 2.19168Z" />
                          <path d="M14.3861 13.4268H2.35637C1.35486 13.4268 0.542969 12.6149 0.542969 11.6134C0.542969 10.6118 1.35486 9.79996 2.35637 9.79996H14.3861C15.3876 9.79996 16.1995 10.6118 16.1995 11.6134C16.1995 12.6149 15.3876 13.4268 14.3861 13.4268Z" />
                          <path d="M25.6239 13.7117L17.58 21.8322C17.4736 21.9396 17.3287 22 17.1775 22H14.0583C13.5548 22 13.3015 21.3924 13.6558 21.0347L21.6997 12.9142C21.8061 12.8068 21.951 12.7464 22.1022 12.7464H25.2214C25.7248 12.7464 25.9782 13.354 25.6239 13.7117Z" />
                        </svg>
                      </span>
                    </span>
                  </Link>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhitepaperSection
